import React from 'react';
import {
  shape, string, func, arrayOf, oneOfType, node,
} from 'prop-types';

import { Alert, Space, List } from 'antd';
import { isArray } from 'lodash-es';

const formatMessage = (message, html) => {
  if (html) {
    return (
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  if (isArray(message)) {
    return (
      <List
        bordered={false}
        size="small"
        dataSource={message}
        renderItem={(item) => <List.Item>{item}</List.Item>}
      />
    );
  }

  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: message }}
    />
  );
};

const ErrorsAlert = ({ errors = [], clearErrors }) => {
  if (!errors?.length) return null;

  return (
    <Space orientation="vertical" style={{ width: '100%', marginBottom: 24 }}>
      {errors.map(({
        key, message, label, html,
      }) => (
        <Alert
          key={key}
          message={label}
          description={formatMessage(message, html)}
          type="error"
          closable
          onClose={clearErrors}
        />
      ))}
    </Space>
  );
};

const errorPropType = shape({
  key: string,
  message: oneOfType([string, node]),
});

ErrorsAlert.propTypes = {
  errors: arrayOf(errorPropType),
  clearErrors: func.isRequired,
};

export default ErrorsAlert;
